import React, { useEffect, useState } from 'react';
import { ArrowBack } from '@mui/icons-material';
import { Box, Button, Chip, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../utils/api';

const ProductBackupDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [backup, setBackup] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.getProductBackupDetails(id)
      .then((response) => setBackup(response?.data?.data || null))
      .catch(() => setError('Backup products could not be loaded.'));
  }, [id]);

  if (error) return <Typography color="error">{error}</Typography>;
  if (!backup) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>;

  return (
    <Box sx={{ maxWidth: 1600, mx: 'auto', pb: 3 }}>
      <Button startIcon={<ArrowBack />} onClick={() => navigate('/backup')} sx={{ mb: 2, textTransform: 'none', color: '#512DA8' }}>Back to backups</Button>
      <Typography sx={{ color: '#1D1F2C', fontSize: { xs: 28, md: 32 }, fontWeight: 700 }}>{backup.level3Name}</Typography>
      <Typography sx={{ color: '#667085', fontSize: 16, mb: 3 }}>Last backed up on {new Date(backup.updatedAt || backup.createdAt).toLocaleString()} · {backup.productCount} products</Typography>
      <Paper variant="outlined" sx={{ borderColor: '#E0E2E7', borderRadius: 2, overflow: 'hidden' }}>
        <TableContainer><Table sx={{ minWidth: 800 }}>
          <TableHead><TableRow sx={{ backgroundColor: '#F9FAFB' }}>
            <TableCell sx={{ fontWeight: 700 }}>Product number</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>SKU</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Stock</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
          </TableRow></TableHead>
          <TableBody>
            {(backup.products || []).map((product, index) => <TableRow key={product._id || index} hover>
              <TableCell sx={{ fontWeight: 700 }}>{product?.productOverview?.productNumber?.[0] || product?.productOverview?.ElectrowizCode?.[0] || '-'}</TableCell>
              <TableCell>{product?.inventory?.sku || '-'}</TableCell>
              <TableCell>{product?.inventory?.qtyAvailable ?? 0}</TableCell>
              <TableCell><Chip label={product?.status || 'PUBLISHED'} size="small" sx={{ fontWeight: 700 }} /></TableCell>
            </TableRow>)}
            {!(backup.products || []).length && <TableRow><TableCell colSpan={4} align="center" sx={{ py: 7, color: '#667085' }}>No products were in this category when the backup was created.</TableCell></TableRow>}
          </TableBody>
        </Table></TableContainer>
      </Paper>
    </Box>
  );
};

export default ProductBackupDetails;
